import React from 'react'

const NotFound = () => {
  return (
    <section className="container mainContainer">
      <h1 className="title">Erro: 404 Not Found</h1>
      <p>Página não encontrada.</p>
    </section>
  )
}

export default NotFound
